<template>
  <div
    class="zt-select-item zt-select-item--link relative flex cursor-pointer items-center px-3 tracking-normal no-underline outline-none"
    :class="{
      'zt-select-item--active': isActive,
      'pl-8': itemGroup,
    }"
    @click="handleSelect"
  >
    <zt-icon v-if="prependIcon" :name="prependIcon" class="mr-2" />
    <div
      class="zt-select-item__content flex flex-wrap items-center self-center overflow-hidden py-3"
    >
      {{ displayText }}
    </div>
  </div>
</template>

<script>
import utils from '../../../../utils/helpers'
import ztIcon from '../ztIcon/ztIcon.vue'

export default {
  name: 'ztOption',
  inheritAttrs: false,
  components: {
    ztIcon,
  },
  inject: {
    selectedValue: {
      from: 'selectedValue',
      default: '',
    },
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    itemText: {
      type: [String, Array],
      default: '',
    },
    itemGroup: {
      type: Boolean,
      default: false,
    },
    prependIcon: {
      type: String,
      default: null,
    },
  },
  computed: {
    displayText() {
      return this.getTextObject(this.item)
    },
    isActive() {
      return this.selectedValue === this.displayText
    },
  },
  methods: {
    getTextObject(item) {
      const text =
        this.itemText === ''
          ? utils.getPropertyItem(item, 'text')
          : utils.getPropertyItem(item, this.itemText)
      return typeof text === 'string' ? text : String(text)
    },
    handleSelect() {
      this.$emit('select', this.item)
    },
  },
}
</script>


